import { AwsRum, AwsRumConfig } from "aws-rum-web";
import { isLocal } from "./detectEnv";

export let awsRum: AwsRum;

export async function initAwsRum(alias: string) {
  try {
    if (isLocal()) return;

    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      endpoint: "https://dataplane.rum.us-west-2.amazonaws.com",
      identityPoolId: "us-west-2:6c0f0fb6-93ed-4487-9204-2a38a791ff65",
      telemetries: ["errors", "performance", "http"],
      allowCookies: true,
      enableXRay: false,
    };

    const APPLICATION_ID = "22f2bd81-e818-421a-8cea-298df742e9f7";
    const APPLICATION_VERSION = "1.0.0";
    const APPLICATION_REGION = "us-west-2";

    awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config,
    );

    awsRum.addSessionAttributes({ alias: alias });
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.log("RUM client initialize fail with error: ", error);
  }
}

export const sendCustomRUMEvent = (eventName: string, eventData: object) => {
  if (isLocal()) return;
  awsRum.recordEvent(eventName, eventData);
};
